import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { linkedInReplyState } from "../state";

const AUTO_DISMISS_MS = 5000;

const STRIP_CONTENT = {
  TO_BE_CONNECTED: {
    className: "pending",
    text: "We are connecting your LinkedIn account",
    dismissible: false
  },
  CONNECTED: {
    className: "success",
    text: "LinkedIn account connected",
    dismissible: true
  },
  FAILED: {
    className: "danger",
    text: "Couldn't connect your LinkedIn account — try again",
    dismissible: true
  },
  DUPLICATE: {
    className: "duplicate",
    text: "The LinkedIn account you tried to connect is already connected",
    dismissible: true
  }
};

const OauthConnectStatusStrip = observer(() => {
  const status = linkedInReplyState?.oauthConnectStatus;
  const content = status && STRIP_CONTENT[status];
  const isDismissible = Boolean(content?.dismissible);

  useEffect(() => {
    if (!isDismissible) {
      return undefined;
    }
    const timer = setTimeout(() => {
      linkedInReplyState.setOauthConnectStatus(null);
    }, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [status, isDismissible]);

  if (!content) {
    return null;
  }

  const isPending = content.className === "pending";

  return (
    <div className={`oauthConnectStatusStrip ${content.className}`}>
      {isPending ? (
        <div className="circleLoader animatedButton loading">
          <span className="load-text"></span>
        </div>
      ) : (
        <span className="glyph">
          {content.className === "success" ? "✓" : "!"}
        </span>
      )}
      <span className="stripText">{content.text}</span>
      {content.dismissible && (
        <span
          className="stripClose"
          onClick={() => linkedInReplyState.setOauthConnectStatus(null)}
        >
          &times;
        </span>
      )}
    </div>
  );
});

export { OauthConnectStatusStrip };
export default OauthConnectStatusStrip;
